import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {BulletinForm} from 'src/app/bulletins/BulletinForm/BulletinForm';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const CreateBulletinPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Bulletins}>
      <BulletinForm id={undefined} mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.BulletinCreate(':view'),
  element: <CreateBulletinPage />,
  module: ModuleEnum.Bulletins,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateBulletinPage;
